import { render } from "./PodsUsage.vue?vue&type=template&id=09881b09"
import script from "./PodsUsage.vue?vue&type=script&lang=js"
export * from "./PodsUsage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__